export type FormStep = {
  label: string;
  percent: number;
};

export type InspectionFormStepKey =
  | "photos"
  | "description"
  | "address"
  | "contact"
  | "email_otp"
  | "review";

export type InspectionFormStep = {
  key: InspectionFormStepKey;
  label: string;
};

export type RecurringFormStepKey =
  | "choose_package"
  | "choose_plan"
  | "date_time"
  | "service_area"
  | "details"
  | "email_otp"
  | "review";

export type RecurringFormStep = {
  key: RecurringFormStepKey;
  label: string;
};

export type ScheduleFormStepKey =
  | "choose_package"
  | "date_time"
  | "service_area"
  | "details"
  | "email_otp"
  | "review";

export type ScheduleFormStep = {
  key: ScheduleFormStepKey;
  label: string;
};

export const FREE_ESTIMATION_FORM_STEPS: FormStep[] = [
  { label: "Category", percent: 20 },
  { label: "Service", percent: 35 },
  { label: "Service", percent: 50 },
  { label: "Date & Time", percent: 65 },
  { label: "Your Details", percent: 80 },
  { label: "Service Area", percent: 90 },
  { label: "Review", percent: 100 },
];

export const SCHEDULE_FORM_STEPS: ScheduleFormStep[] = [
  // Percent is computed dynamically in the page, because the OTP step is conditional.
  { key: "choose_package", label: "Choose Package" },
  { key: "date_time", label: "Date & Time" },
  { key: "service_area", label: "Service Area" },
  { key: "details", label: "Details" },
  { key: "email_otp", label: "Verify Email" },
  { key: "review", label: "Review" },
];

export const INSPECTION_FORM_STEPS: InspectionFormStep[] = [
  // Percent is computed dynamically in the page, because the OTP step is conditional.
  // Keep this list as the source of truth for step ordering and labels.
  // Order: photos -> description -> address -> contact -> email_otp -> review
  { key: "photos", label: "Photos" },
  { key: "description", label: "Description" },
  { key: "address", label: "Service Address" },
  { key: "contact", label: "Your Details" },
  { key: "email_otp", label: "Verify Email" },
  { key: "review", label: "Review" },
];

export const RECURRING_FORM_STEPS: RecurringFormStep[] = [
  // Percent is computed dynamically in the page, because the OTP step is conditional.
  { key: "choose_package", label: "Choose Package" },
  { key: "choose_plan", label: "Choose Plan" },
  { key: "date_time", label: "Date & Time" },
  { key: "service_area", label: "Service Area" },
  { key: "details", label: "Details" },
  { key: "email_otp", label: "Verify Email" },
  { key: "review", label: "Review" },
];

export const JOIN_AS_VENDOR_FORM_STEPS: FormStep[] = [
  { label: "Company Type", percent: 12 },
  { label: "Business Information", percent: 37 },
  { label: "Contact Person", percent: 50 },
  { label: "Business address", percent: 62 },
  { label: "Documents", percent: 75 },
  { label: "Take Selfie", percent: 87 },
  { label: "Membership Package", percent: 25 },
  { label: "Review", percent: 100 },
];
export const COMPANY_MEMBERSHIP_FORM_STEPS: FormStep[] = [
  { label: "Company Type", percent: 12 },
  { label: "Business Information", percent: 37 },
  { label: "Business address", percent: 62 },
  { label: "Documents", percent: 75 },
  { label: "Take Selfie", percent: 87 },
  { label: "Membership Package", percent: 25 },
  { label: "Review", percent: 100 },
];
